<template>
  <div class="knowDynamic tw-w-full tw-bg-white tw-py-24">
    <div class="tw-flex tw-flex-col tw-items-center">
      <h2
        class="tw-text-textMain tw-font-semibold tw-text-xl lg:tw-text-4xl tw-mb-4"
        v-html="$t('了解天晟最新动态')"
      ></h2>
      <p
        class="tw-w-full tw-text-center tw-text-sm tw-text-textDisabled tw-px-4"
      >
        {{ $t("获取天晟在产业区块链与Web3领域的前沿洞察、实战案例与深度观点") }}
      </p>
      <div class="dynamic-main tw-mx-auto tw-mt-8">
        <b-row>
          <!-- 大屏幕：每行4个卡片 -->
          <b-col
            cols="12"
            md="6"
            sm="6"
            lg="3"
            xl="3"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div
              class="card-item tw-relative tw-rounded-lg tw-shadow-md tw-transition-all tw-duration-300 hover:tw-shadow-lg tw-mt-6"
              @click="handleClickRoute(item)"
            >
              <img
                :src="item?.coverImage || defaultImage"
                alt=""
                class="tw-w-full tw-h-44 tw-object-cover tw-rounded-t-lg"
              />
              <div
                class="card-content tw-px-5 tw-py-6.5 tw-bg-white tw-rounded-b-lg"
              >
                <p class="tw-text-textInfo tw-mt-7">
                  {{ item.title }}
                </p>
              </div>
            </div>
          </b-col>
          <b-col>
            <div
              class="tw-w-full tw-flex tw-items-center tw-justify-center tw-mt-8"
            >
              <span
                class="tw-text-textLight tw-text-center tw-text-sm tw-cursor-pointer tw-py-2 tw-px-5 tw-border hover:tw-text-primary hover:tw-border-primary"
                @click="handleClickRoute()"
                style="border-radius: 100px"
              >
                {{ $t("更多动态") }}
                <b-icon icon="chevron-right" class="tw-w-3 tw-h-3"></b-icon>
              </span>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { articlesApi } from "@/api/modules/home";
export default {
  name: "knowDynamic",
  props: {},
  components: {},
  data() {
    return {
      isVisible: false,
      observer: null,
      defaultImage: new URL("@/assets/home/01.png", import.meta.url).href,
      dataList: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getList();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
        }
      );

      this.observer.observe(this.$el);
    },

    async getList() {
      const { code, data } = await articlesApi({
        pageSize: 4,
        pageIndex: 1,
      });
      if (code === 0) {
        this.dataList = data.list;
      }
    },
    handleClickRoute(item) {
      if (!item) {
        this.$router.push({
          path: `/dynamics`,
        });
        return;
      }
      localStorage.setItem("detailForm", JSON.stringify(item));
      const routeData = this.$router.resolve({
        path: `/dynamics/` + item.id,
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}
.dynamic-main {
  padding: 0 16px;
  max-width: 1300px;
}
.card-item {
  height: 280px;
  overflow: hidden;
  border-radius: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0px 0px 20px 0px rgba(0, 14, 72, 0.05);
}

.card-item:hover {
  box-shadow: 0px 0px 20px 0px rgba(0, 14, 72, 0.1);
}
.swiper-but {
}
</style>
